import { useState } from "react";
import CredentialsHeader from "@/components/header/Header";
import CredentialsFooter from "@/components/footer/Footer";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { IdentifierValidationResponse } from "@/models/continente-credentials/loyaltycard/IdentifierValidationResponse";
import { loyaltyCardService } from "@/services/continente-credentials/loyaltycard/LoyaltyCardService";
import { Button } from "@/components/ui/button";
import Form from "@/components/Form/Form";
import { useForm } from "react-hook-form";
import { useApiResponseHandler } from "@/hooks/useApiResponseHandler";
import { tryCatch } from "@/utils/try-catch";
import SimpleErrorMessage from "@/components/error-message/new-error-message";
import useFooterDisplayMode from "@/hooks/useFooterDisplayMode";

export default function LoyaltyCardAssociationSuccess() {
  const { t } = useTranslation();
  const location = useLocation<IdentifierValidationResponse>();
  const [loading, setLoading] = useState(false);
  const { displayMode, excludeAssetKey } = useFooterDisplayMode();
  const nextStep = location.state?.nextStep || "";

  const { handleResponse } = useApiResponseHandler();

  const formState = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });

  const {
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = formState;

  const onSubmit = async () => {
    setLoading(true);
    const { data: response, error } = await tryCatch(loyaltyCardService.loyaltyCardSuccessAssociation(nextStep));

    handleResponse(response, {
      setError
    }, error);

    setLoading(false);
  };

  return (
    <Form
      id="CardAssociation"
      form={formState}
      autoComplete="off"
      onSubmit={(e) => {
        clearErrors();
        handleSubmit(onSubmit)(e);
      }}
    >
      <div className="flex flex-col gap-12 pb-2">
        <div className="justify-center">
          <CredentialsHeader
            title={t("loyalty_card_association_success.header_title")}
            subtitle={t("loyalty_card_association_success.header_message")}
            showLoading={loading}
          />
        </div>
        {displayMode !== "none" && (
          <div
            role="note"
            aria-label={t(displayMode === "carousel" ? "accessibility.signin.icons_carousel" : "accessibility.signin.icons")} className="flex flex-col">
            <CredentialsFooter
              contextualInformationVisible
              displayMode={displayMode}
              excludeAssetKey={excludeAssetKey}
            />
          </div>
        )}
        <Button>{t("loyalty_card_association_success.button_next_message")}</Button>
        <SimpleErrorMessage error={
          typeof errors.blocked?.message === "string"
            ? errors.blocked.message
            : typeof errors.submitError?.message === "string"
              ? errors.submitError.message
              : ""
        } />
        <div className="flex flex-col">
          <CredentialsFooter displayMode="none" />
        </div>
      </div>
    </Form>
  );
}
